module.exports = __webpack_public_path__ + "static/media/category4.be9648c0.png";